export const getFileFingerprint = async (file: File): Promise<string> => {
  const digest = await crypto.subtle.digest("SHA-1", await file.arrayBuffer());
  const hex = [...new Uint8Array(digest)]
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");

  return `sha1:${hex}`;
};
